/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import styled from 'styled-components';
import StyledProps from '../theme/AppThemeInterface';

interface BodyProps {
  hiddenViewHeader?: boolean;
  hiddenDrawer?: boolean;
}

const Body = styled.div`
  position: relative;
  background-color: ${({ theme }: StyledProps) => theme.primaryBackgroundColor};
  height: calc(
    100% - ${({ theme }: StyledProps) => theme.viewHeaderHeightSmall} -
      ${({ theme, hiddenViewHeader }: StyledProps & BodyProps) =>
        hiddenViewHeader ? '0px' : theme.viewHeaderHeightSmall}
  );
  width: calc(100% - ${({ theme, hiddenDrawer }: StyledProps & BodyProps) => hiddenDrawer ? '0px' : theme.viewHeaderHeightSmall});
  top: calc(
    ${({ theme }: StyledProps) => theme.viewHeaderHeightSmall} +
      ${({ theme, hiddenViewHeader }: StyledProps & BodyProps) =>
        hiddenViewHeader ? '0px' : theme.viewHeaderHeightSmall}
  );
  left: ${({ theme, hiddenDrawer }: StyledProps & BodyProps) => hiddenDrawer ? '0px' : theme.viewHeaderHeightSmall};
  -ms-overflow-style: scrollbar;

  @media print {
    top: 0;
    width: 100%;
    left: 0;

    background-color: white;
    .highcharts-axis-labels,
    .highcharts-axis-title,
    .highcharts-legend-item > text {
      fill: #2a2a2b;
    }
  }
`;

export default Body;
